import { render, staticRenderFns } from "./ObservedImage.vue?vue&type=template&id=5842d626"
import script from "./ObservedImage.vue?vue&type=script&lang=js"
export * from "./ObservedImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports